import { notificationActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: [],
  created: false,
  updated: false,
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case notificationActions.NOTIFICATIONS_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || false,
        created: state.created,
        error: null
      };
    case notificationActions.NOTIFICATIONS_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        created: false,
        error: action.error
      };
    case notificationActions.NOTIFICATIONS_NEW:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: true,
        error: null
      };
    case notificationActions.NOTIFICATIONS_UPDATED:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        updated: true,
        error: null
      };
    case notificationActions.NOTIFICATIONS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: false,
        error: null
      };
    case notificationActions.NOTIFICATIONS_RESET:
      return {
        ...state,
        isLoading: false,
        data: [],
        created: false,
        error: null
      };
    default:
      return state;
  }
};
